import api from '../api/apicheckout';
export const usuario = {
	state: {
		usuario: undefined
	}
	,
	reducers: {
		definirUsuario: (state, usuarioResponse) => {
			console.log('::: REDUCER: DEFINIR USUARIO :::: ', usuarioResponse)
			return {
				...state,
				usuario: usuarioResponse
			}
		},
	},
	effects: (dispatch) => ({
		async asyncLogin(payload) {
			await api.post('Autenticacao/Logar', payload, {
				headers: { 'Content-Type': 'application/json' }
			}).then(function (response) {
				console.log(':::: USUARIO [SUCESSO] ::::', response.data);
				dispatch.usuario.definirUsuario(response.data);
			}).catch(function (error) {
				console.log('USUARIO [ERROR]:', error);
				const objVazio = { id: 0 };
				dispatch.usuario.definirUsuario(objVazio);
			});
		},
	}),
}
